export function fiTextToHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

export function fiHtmlToText(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent;
}
